// src/plugins/posthog.js
import posthog from 'posthog-js'

export default {
  install(Vue) {
    const apiToken = process.env.MIX_POSTHOG_API_TOKEN;
    const apiUrl = process.env.MIX_POSTHOG_API_URL;
    posthog.init(apiToken, {
      api_host: apiUrl,
      defaults: '2025-05-24',
    })

    // Identify user if logged in
    if (window.ddRumData) {
      posthog.identify(
        window.ddRumData.u_uuid,
        {
          partner_uuid: window.ddRumData.p_uuid,
          partner_name: window.ddRumData.p_name,
        },
      );
    }

    Vue.config.globalProperties.$posthog = posthog;
  },
}
